module.exports = __webpack_public_path__ + "static/media/970-250.c398195a.gif";